/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { TermReportBodyDto } from '../model/termReportBodyDto';
// @ts-ignore
import { TermReportPreviewDto } from '../model/termReportPreviewDto';
// @ts-ignore
import { WeightCoverageResponseDto } from '../model/weightCoverageResponseDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class DocumentsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Generate attendance report (PDF, Excel, CSV)
     * @endpoint get /documents/attendance
     * @param format 
     * @param termId 
     * @param academicYearId 
     * @param classId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetAttendance(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetAttendance(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetAttendance(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetAttendance(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetAttendance.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'classId',
            <any>classId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/documents/attendance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate all learner term reports for a class as a ZIP archive
     * @endpoint post /documents/class/{classId}/term-reports/bulk
     * @param classId 
     * @param format 
     * @param termId 
     * @param termReportBodyDto 
     * @param academicYearId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetBulkTermReports(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetBulkTermReports(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetBulkTermReports(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetBulkTermReports(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetBulkTermReports.');
        }
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetBulkTermReports.');
        }
        if (termId === null || termId === undefined) {
            throw new Error('Required parameter termId was null or undefined when calling documentGenerationControllerGetBulkTermReports.');
        }
        if (termReportBodyDto === null || termReportBodyDto === undefined) {
            throw new Error('Required parameter termReportBodyDto was null or undefined when calling documentGenerationControllerGetBulkTermReports.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/zip'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/term-reports/bulk`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: termReportBodyDto,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate all learner transcripts for a class as a ZIP archive
     * @endpoint post /documents/class/{classId}/transcripts/bulk
     * @param classId 
     * @param format 
     * @param termReportBodyDto 
     * @param termId 
     * @param academicYearId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetBulkTranscripts(classId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetBulkTranscripts(classId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetBulkTranscripts(classId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetBulkTranscripts(classId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetBulkTranscripts.');
        }
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetBulkTranscripts.');
        }
        if (termReportBodyDto === null || termReportBodyDto === undefined) {
            throw new Error('Required parameter termReportBodyDto was null or undefined when calling documentGenerationControllerGetBulkTranscripts.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/zip'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/transcripts/bulk`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: termReportBodyDto,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate class performance report (PDF, Excel, CSV)
     * @endpoint get /documents/class/{classId}/performance
     * @param classId 
     * @param format 
     * @param termId 
     * @param academicYearId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetClassPerformance(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetClassPerformance(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetClassPerformance(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetClassPerformance(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetClassPerformance.');
        }
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetClassPerformance.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/performance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate learner rankings report (PDF, Excel, CSV)
     * @endpoint get /documents/learners/rankings
     * @param format 
     * @param termId 
     * @param academicYearId 
     * @param classId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetLearnerRankings(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetLearnerRankings(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetLearnerRankings(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetLearnerRankings(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetLearnerRankings.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'classId',
            <any>classId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/documents/learners/rankings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate learner academic transcript (PDF, Excel, CSV)
     * @endpoint post /documents/learner/{learnerId}/transcript
     * @param learnerId 
     * @param format 
     * @param termReportBodyDto 
     * @param termId 
     * @param academicYearId 
     * @param classId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetLearnerTranscript(learnerId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetLearnerTranscript(learnerId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetLearnerTranscript(learnerId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetLearnerTranscript(learnerId: number, format: 'pdf' | 'xlsx' | 'csv', termReportBodyDto: TermReportBodyDto, termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (learnerId === null || learnerId === undefined) {
            throw new Error('Required parameter learnerId was null or undefined when calling documentGenerationControllerGetLearnerTranscript.');
        }
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetLearnerTranscript.');
        }
        if (termReportBodyDto === null || termReportBodyDto === undefined) {
            throw new Error('Required parameter termReportBodyDto was null or undefined when calling documentGenerationControllerGetLearnerTranscript.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'classId',
            <any>classId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let localVarPath = `/documents/learner/${this.configuration.encodeParam({name: "learnerId", value: learnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/transcript`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: termReportBodyDto,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate school-wide overview report (PDF, Excel, CSV) — Principal only
     * @endpoint get /documents/school/overview
     * @param format 
     * @param termId 
     * @param academicYearId 
     * @param classId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetSchoolOverview(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetSchoolOverview(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetSchoolOverview(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetSchoolOverview(format: 'pdf' | 'xlsx' | 'csv', termId?: number, academicYearId?: number, classId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetSchoolOverview.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'classId',
            <any>classId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/documents/school/overview`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate CAPS-compliant term report for a class (PDF, Excel, CSV)
     * @endpoint post /documents/class/{classId}/term-report
     * @param classId 
     * @param format 
     * @param termId 
     * @param termReportBodyDto 
     * @param academicYearId 
     * @param grade Filter by grade (1–12)
     * @param dateFrom 
     * @param dateTo 
     * @param learnerId Filter term report to a single learner
     * @param showBreakdown Include per-assessment breakdown in term report PDF
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetTermReport(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public documentGenerationControllerGetTermReport(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public documentGenerationControllerGetTermReport(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public documentGenerationControllerGetTermReport(classId: number, format: 'pdf' | 'xlsx' | 'csv', termId: number, termReportBodyDto: TermReportBodyDto, academicYearId?: number, grade?: number, dateFrom?: string, dateTo?: string, learnerId?: number, showBreakdown?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetTermReport.');
        }
        if (format === null || format === undefined) {
            throw new Error('Required parameter format was null or undefined when calling documentGenerationControllerGetTermReport.');
        }
        if (termId === null || termId === undefined) {
            throw new Error('Required parameter termId was null or undefined when calling documentGenerationControllerGetTermReport.');
        }
        if (termReportBodyDto === null || termReportBodyDto === undefined) {
            throw new Error('Required parameter termReportBodyDto was null or undefined when calling documentGenerationControllerGetTermReport.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'format',
            <any>format,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'grade',
            <any>grade,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateFrom',
            <any>dateFrom,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dateTo',
            <any>dateTo,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'showBreakdown',
            <any>showBreakdown,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/term-report`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: termReportBodyDto,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Preview term report data as JSON before downloading
     * @endpoint get /documents/class/{classId}/term-report/preview
     * @param classId 
     * @param termId 
     * @param learnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetTermReportPreview(classId: number, termId: number, learnerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TermReportPreviewDto>;
    public documentGenerationControllerGetTermReportPreview(classId: number, termId: number, learnerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TermReportPreviewDto>>;
    public documentGenerationControllerGetTermReportPreview(classId: number, termId: number, learnerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TermReportPreviewDto>>;
    public documentGenerationControllerGetTermReportPreview(classId: number, termId: number, learnerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetTermReportPreview.');
        }
        if (termId === null || termId === undefined) {
            throw new Error('Required parameter termId was null or undefined when calling documentGenerationControllerGetTermReportPreview.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'termId',
            <any>termId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'learnerId',
            <any>learnerId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/term-report/preview`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TermReportPreviewDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assessment weight completeness per term and subject for a class across an academic year
     * @endpoint get /documents/class/{classId}/weight-coverage
     * @param classId 
     * @param academicYearId Defaults to the school\&#39;s current academic year
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public documentGenerationControllerGetWeightCoverage(classId: number, academicYearId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<WeightCoverageResponseDto>;
    public documentGenerationControllerGetWeightCoverage(classId: number, academicYearId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<WeightCoverageResponseDto>>;
    public documentGenerationControllerGetWeightCoverage(classId: number, academicYearId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<WeightCoverageResponseDto>>;
    public documentGenerationControllerGetWeightCoverage(classId: number, academicYearId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling documentGenerationControllerGetWeightCoverage.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'academicYearId',
            <any>academicYearId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/documents/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/weight-coverage`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WeightCoverageResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
